import React from "react";
import { compose, withState } from "recompose";
import { Field } from "formik";
import { File } from "../../native";

export default compose(withState("filename", "setFilename", null))(
  ({ filename, setFilename, ...props }) => (
    <Field
      name={props.name}
      render={({ field, form: { touched, errors, values, setValues } }) => {
        const error = errors[field.name];
        const isDirty = touched[field.name];
        return (
          <File
            {...field}
            {...props}
            filename={filename}
            error={isDirty && error}
            value=""
            onChange={e => {
              const file = e.target.files[0];

              setFilename(file.name);
              setValues({
                ...values,
                [field.name]: file
              });
            }}
          />
        );
      }}
    />
  )
);



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/File/index.js